import util from "@/util";

function tmpToFiexd(data) {
    return util.toFiexd(data);
}

function tmpParseInt(data) {
    let tmp = parseInt(data);
    return tmp ? tmp : 0;
}

function tmpParseFloat(data) {
    let tmp = parseFloat(data);
    return tmp ? tmp : 0;
}

let FbaFormFields = {
    '其他': {
        '样品采购': [
            {name: '序号', key: 'xuhao', readonly: true},
            {name: 'SKU', key: 'sku'},
            {name: '采购类型', key: 'leixing'},
            {name: '供应商', key: 'gongyingshang'},
            {name: '产品中文名', key: 'name'},
            {name: '数量', key: 'shuliang', type: 'number', format: tmpParseInt},
            {name: '单价(估价)', key: 'danjia', type: 'number', format: tmpToFiexd},
            {name: '运费(估价)', key: 'yunfei', type: 'number', format: tmpToFiexd},
            {name: '合计(元）', key: 'heji', type: 'number', readonly: true},
            {name: '备注', key: 'beizhu'},
        ],
        'FBA备货申请': [
            {name: '序号', key: 'xuhao', readonly: true},
            {name: 'SKU', key: 'sku'},
            {name: '采购类型', key: 'caigouleixing'},
            {name: '供应商', key: 'gongyingshang'},
            {name: '产品中文名', key: 'name'},
            {name: '数量', key: 'shuliang', type: 'number', format: tmpParseInt},
            {name: '单价（估价）', key: 'danjia', type: 'number', format: tmpToFiexd},
            {name: '运费（估价）', key: 'yunfei', type: 'number', format: tmpToFiexd},
            {name: '合计（元）', key: 'heji', type: 'number', readonly: true},
            {name: '建单渠道', key: 'jiandanqudao'},
            {name: '物流方式', key: 'wuliufangshi'},
            {name: '备注', key: 'beizhu'},
        ],
        'FBA确认申请': [
            {name: '序号', key: 'xuhao', readonly: true},
            {name: 'SKU', key: 'sku'},
            {name: '品名', key: 'pinming'},
            {name: '订单号', key: 'dingdanhao'},
            {name: '数量', key: 'shuliang', type: 'number', format: tmpParseInt},
            {name: '账号', key: 'zhanghao'},
            {name: '目的国', key: 'mudiguo'},
            {name: '物流渠道', key: 'wuliuqudao'},
            {name: '单箱起重量', key: 'danxiangqizhong', type: 'number', format: tmpParseFloat},
            {name: '计费的每箱重量', key: 'meixiangzhongliang', type: 'number', format: tmpParseFloat},
            {name: '单价', key: 'danjia', type: 'number', format: tmpToFiexd},
            {name: '附加费', key: 'fujiafei', type: 'number', format: tmpToFiexd},
            {name: '预估运费', key: 'yuguyunfei', type: 'number', format: tmpToFiexd},
            {name: '申请人', key: 'shenqingren'},
        ],
        'FBAOther': [
            {name: 'FBA箱规限制', key: 'fbaxianggui'},
            {name: '发货物流方式箱规限制', key: 'fahuoxianggui'},
            {name: '实际单箱计重', key: 'danxiangjizhong'},
            {name: '实际单箱产品数量', key: 'danxiangshuliang'},
            {name: '实际单箱外箱尺寸', key: 'danxiangchicun'},
            {name: '是否需要定制大箱', key: 'dingzhidaxiang'},
            {name: '质检要求', key: 'zhijianyaoqiu'},
        ],
        '发货申请': [
            {name: '序号', key: 'xuhao', readonly: true},
            {name: 'SKU', key: 'sku'},
            {name: '采购类型', key: 'caigouleixing'},
            {name: '供应商', key: 'gongyingshang'},
            {name: '产品中文名', key: 'name'},
            {name: '数量', key: 'shuliang', type: 'number', format: tmpParseInt},
            {name: '单价（估价）', key: 'danjia', type: 'number', format: tmpToFiexd},
            {name: '运费（估价）', key: 'yunfei', type: 'number', format: tmpToFiexd},
            {name: '合计（元）', key: 'heji', type: 'number', readonly: true},
            {name: '建单渠道', key: 'jiandanqudao'},
            {name: '物流方式', key: 'wuliufangshi'},
            {name: '备注', key: 'beizhu'},
        ],
    }
}
export default FbaFormFields